import { LanguageOption } from 'src/utils/languages';
import { QuestionData } from './types';

export const DEFAULT_ENGLISH_LANGUAGE: LanguageOption = {
  label: 'English',
  value: 'en-GB',
  isDefault: true,
};

export const DUMMY_ALL_LANGUAGES: LanguageOption[] = [
  DEFAULT_ENGLISH_LANGUAGE,
  { label: 'French', value: 'fr-FR' },
  { label: 'Spanish', value: 'es-ES' },
];

export const DUMMY_DEFAULT_LANGUAGE_ONLY: LanguageOption[] = [
  DEFAULT_ENGLISH_LANGUAGE,
];

export const INITIAL_FORM_STATE = {
  title: '',
  description: '',
  categoryName: '',
  categoryDescription: '',
  questions: [] as QuestionData[],
  selectedLanguages: [] as LanguageOption[],
  selectedCountryCodes: [] as string[],
  autoReviewEnabled: false,
};
